<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Gestion, droits et restrictions
        </p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Espace de contrôle de tous les accès à vos Neopass afin d’assurer une
          utilisation sécurisée et confidentielle pour toutes les personnes
          internes ou externes à votre structure.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>
    <div v-if="allowed">
      <!-- Contenu -->
      <div class="flex flex-col mt-16 mb-16">
        <div class="-my-2 py-2">
          <message-header :message-header="messageHeader" />

          <div
            class="relative min-w-full align-middle shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
          >
            <h3 class="mt-15 mb-10 lg:mb-15 w-full">
              Gestion, droits et restrictions
            </h3>

            <!-- TODO: Move this to a component -->
            <div class="flex justify-center items-center">
              <nav
                class="flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full"
              >
                <router-link
                  :to="{ name: 'PermissionsRoles' }"
                  class="flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light"
                  :class="{
                    'text-indigo-600 font-normal':
                      tabDisplay == 'PermissionsRoles',
                  }"
                  v-if="$can(constants.PERMISSION_GESTION_DROITS_ROLE_LISTE)"
                >
                  Gestion des rôles
                </router-link>

                <router-link
                  :to="{ name: 'PermissionsReferents' }"
                  class="flex-shrink-0 text-2xl inline-block pl-4 md:pl-0 hover:text-pink-600 font-light"
                  v-if="
                    $can(constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE)
                  "
                  :class="{
                    'text-indigo-600 font-normal':
                      tabDisplay == 'PermissionsReferents' ||
                      tabDisplay == 'referentBeneficiaries' ||
                      tabDisplay == 'PermissionsBeneficiariesReferent',
                  }"
                >
                  Gestion des référents
                </router-link>

                <router-link
                  :to="{ name: 'PermissionsBeneficiaries' }"
                  class="flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0"
                  v-if="
                    $can(constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE)
                  "
                  :class="{
                    'text-indigo-600 font-normal':
                      tabDisplay == 'PermissionsBeneficiaries',
                  }"
                >
                  Droits des bénéficiaires
                </router-link>
              </nav>
              <icon
                class="ml-3 text-indigo-600 md:hidden block"
                name="arrow-right_1"
              />
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <page-not-allowed v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageNotAllowed from './../../components/PageNotAllowed';
import MessageHeader from './../../components/MessageHeader';
import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';
import Constants from './../../constants';

export default {
  components: {
    PageNotAllowed,
    MessageHeader,
    Illustration,
    Icon,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
      messageHeader: 'permissions/messageHeader',
      saving: 'permissions/saving',
    }),

    tabDisplay: function () {
      return this.$route.name;
    },
  },
};
</script>
